var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{staticClass:"btn-language-prop",attrs:{"variant":_vm.isEnabled ? 'primary' : 'white',"size":"sm"}},[_c('i',{staticClass:"fa-fw fas fa-flag",attrs:{"title":_vm.title},on:{"click":function($event){$event.preventDefault();return _vm.toggle.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }